/* PZ Sep26 #4: variant cards (collection grids, .m-product-card[data-variant-id]) — when a swatch in the card is
   clicked, the theme's pcard-swatch already swaps the image, the price and the hidden name="id" input. This keeps the
   REST of the card on the same shade: data-variant-id, both links (?variant=), the "Product - Shade" title and the
   shade line. The hover image / hover video belong to the original shade's media block, so they are dropped after a
   switch. Runs after the theme handler (delegated at document level, deferred a tick). Other card render sites are
   untouched: they carry no data-variant-id. */
(function () {
  if (window.__pzVariantCard) return;
  window.__pzVariantCard = true;

  function variantsOf(card) {
    var s = card.querySelector('[data-pcard-variant-picker] script[type="application/json"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function syncCard(card) {
    var input = card.querySelector('input[name="id"]');
    if (!input) return;
    var id = String(input.value || '');
    if (!id || id === card.getAttribute('data-variant-id')) return;
    var list = variantsOf(card);
    var v = list && list.find(function (x) { return String(x.id) === id; });
    if (!v) return;
    card.setAttribute('data-variant-id', id);
    var base = card.getAttribute('data-pz-base-title') || '';
    var url = (card.getAttribute('data-pz-product-url') || '') + '?variant=' + id;
    card.querySelectorAll('a.m-product-card__link, a.m-product-card__name').forEach(function (a) { a.setAttribute('href', url); });
    var name = card.querySelector('.m-product-card__name');
    if (name && base) name.textContent = base + ' - ' + v.title;
    /* shade description: the card's hidden variant select carries variant.metafields.custom.variant_short_desc per variant */
    var descEl = card.querySelector('[data-pz-desc]') || (card.closest('.pz-col__card') || card).querySelector('[data-pz-desc]');
    if (descEl) {
      var opt = card.querySelector('select.product-variant option[data-variant-title="' + (v.title || '').replace(/"/g, '\\"') + '"]');
      var d = (opt && opt.getAttribute('data-variant-short-description')) || descEl.getAttribute('data-pz-desc-fallback') || '';
      descEl.textContent = d;
      if (descEl.classList.contains('pz-shade-desc')) descEl.style.opacity = d ? '' : '0';
    }
    /* 4b: ADD TO CART button follows the selected shade (price / compare-at / sold-out + disabled). The theme's own
       swatch handler has already written this variant's id into the card's first name="id" input (the CTA form). */
    var btn = card.querySelector('.pz-card-cta__btn');
    if (btn) {
      var fmt = (window.MinimogSettings && window.MinimogSettings.money_format) || '{{amount}}';
      var txt = btn.querySelector('[data-atc-text]');
      var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
      if (v.available) {
        btn.disabled = false;
        btn.classList.remove('disabled');
        var money = function (c) { return (typeof formatMoney === 'function') ? formatMoney(c, fmt) : (c / 100).toFixed(2); };
        if (txt) txt.innerHTML = '<span class="btn">' + ((window.MinimogStrings && window.MinimogStrings.addToCart) || 'Add to cart') + '</span><span class="price-wrap"> | <span class="regular-price">' + money(v.price) + '</span>' + (onSale ? ' <s class="compare-at-price">' + money(v.compare_at_price) + '</s>' : '') + '</span>';
      } else {
        btn.disabled = true;
        btn.classList.add('disabled');
        if (txt) txt.innerHTML = '<span class="btn">' + ((window.MinimogStrings && window.MinimogStrings.soldOut) || 'Sold out') + '</span>';
      }
      if (window.pzFitCta) window.pzFitCta(btn);
    }
    /* Best Seller pill: flagged variant ids come from data-pz-best-ids (variant metafield custom.best_seller) */
    var pill = card.querySelector('.pz-bs-pill');
    if (pill) {
      var best = (card.getAttribute('data-pz-best-ids') || '').split(',').filter(Boolean);
      pill.hidden = best.indexOf(id) === -1;
    }
    var hover = card.querySelector('.m-product-card__hover-image');
    if (hover) hover.remove();
    card.classList.remove('m-product-card--show-second-img');
    var vid = card.querySelector('video.pz-card-video');
    if (vid) { try { vid.pause(); } catch (e) {} vid.remove(); }
    card.dispatchEvent(new CustomEvent('pz:variant-card:change', { bubbles: true, detail: { variant: v } }));
  }

  /* ---- CTA fit (Oliver, 27 Sep): a card CTA never wraps and the price never leaves the button. Per button, at the current
     width, apply fallbacks in order until scrollWidth fits: pz-fit-1 side padding, pz-fit-2 letter-spacing (.5px desktop /
     0 mobile), pz-fit-3 hide the struck compare-at, pz-fit-4 font-size -1px. Re-run on resize, on swatch change and when
     cards are appended (infinite scroll). data-pz-fit records the steps used for verification. ---- */
  var FIT_STEPS = ['pz-fit-1', 'pz-fit-2', 'pz-fit-3', 'pz-fit-4'];
  function fits(b) { return b.scrollWidth <= b.clientWidth + 1; }
  function fitCta(b) {
    FIT_STEPS.forEach(function (c) { b.classList.remove(c); });
    b.removeAttribute('data-pz-fit');
    if (fits(b)) return;
    var used = [];
    for (var i = 0; i < FIT_STEPS.length; i++) {
      b.classList.add(FIT_STEPS[i]);
      used.push(i + 1);
      if (fits(b)) break;
    }
    b.setAttribute('data-pz-fit', used.join(','));
  }
  function fitAll() {
    document.querySelectorAll('#MainContent .pz-card-cta__btn, #MainContent a.pz-card-cta--link').forEach(fitCta);
  }
  window.pzFitCta = fitCta;
  window.pzFitCtas = fitAll;
  var fitTimer = null;
  function fitSoon() { clearTimeout(fitTimer); fitTimer = setTimeout(fitAll, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitSoon); else fitSoon();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoon);
  window.addEventListener('load', fitSoon);
  window.addEventListener('resize', fitSoon);
  var grid = document.querySelector('[data-product-container], .pz-col__grid');
  if (grid && 'MutationObserver' in window) new MutationObserver(fitSoon).observe(grid, { childList: true });

  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.m-product-option--node__label');
    if (!label) return;
    var card = label.closest('.m-product-card[data-variant-id]');
    if (!card) return;
    setTimeout(function () { syncCard(card); }, 0);
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.m-product-option--dropdown-select');
    if (!sel) return;
    var card = sel.closest('.m-product-card[data-variant-id]');
    if (card) setTimeout(function () { syncCard(card); }, 0);
  });
})();
